import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

import { removeAlert } from "../../store/app";
import { isValidLendingType } from "../../lib/validations";
import gtag from "../../lib/gtag";
import { Alerts } from "../../components/Alerts";
import { Spinners } from "../../components/Spinners";
import Header from "../../components/Header";
import Login from "../../pages/Login";
import ForgotPassword from "../../pages/ForgotPassword";
import LendingRequests from "../../pages/Requests";
import AppErrorBoundary from "../../components/AppErrorBoundary";
import ProtectedPage from "./ProtectedPage";
import ErrorPage from "../../pages/ErrorPage";
import RequestNew from "../../pages/RequestNew";

function App() {
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state.app.alerts);
  const spinners = useSelector((state) => state.app.spinners);
  const user = useSelector((state) => state.auth.user);
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const lendingTypes = useSelector((state) => state.auth.lendingTypes);
  const defaultUrl = Object.keys(lendingTypes)[0];

  React.useEffect(() => {
    gtag();
  }, []);

  return (
    <div className="text-black text-14 font-sans">
      {!!loggedIn && <Header />}

      <div className="container px-1 py-8">
        <Alerts
          alerts={alerts}
          removeAlert={(id) => dispatch(removeAlert(id))}
        />

        <Spinners spinners={spinners} />

        <AppErrorBoundary>
          <Switch>
            {/* Error */}
            <Route exact path="/error/:errorCode?" component={ErrorPage} />

            {/* Login */}
            <Route exact path="/login" component={Login} />

            {/* Forgot Password */}
            <Route
              exact
              path="/forgot-password/:passwordUpdateToken?"
              component={ForgotPassword}
            />

            <ProtectedPage>
              {/* All the applications / */}
              <Route
                exact
                path="/:lendingType?"
                render={({ match }) => {
                  const { lendingType } = match.params;

                  if (!isValidLendingType(lendingType)) {
                    return <Redirect to={`/${defaultUrl}`} />;
                  }

                  return (
                    <LendingRequests
                      key={lendingType}
                      lendingType={lendingType}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/:lendingType/generate/:id?"
                render={({ location, match, history }) => {
                  const { lendingType } = match.params;

                  if (
                    !user?.access_type.some(
                      (type) => type === "broker_agent" || type === "admin",
                    ) ||
                    !isValidLendingType(lendingType)
                  ) {
                    return <Redirect to={`/${defaultUrl}`} />;
                  }

                  return (
                    <RequestNew
                      history={history}
                      lendingType={lendingType}
                      location={location}
                      match={match}
                    />
                  );
                }}
              />
            </ProtectedPage>
          </Switch>
        </AppErrorBoundary>
      </div>
    </div>
  );
}

export default App;
